"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUNDUP = void 0;
const tab_1 = require("../../../tab");
exports.ROUNDUP = {
    description: 'Rounds a number up, away from 0 (zero)',
    arg_names: ['number', 'num_digits'],
    args_def: [
        {
            types: ['number'],
            required: true,
        },
        {
            types: ['number'],
            required: true,
        },
    ],
    args_description: [
        'Any real number that you want rounded up',
        'The number of digits to which you want to round number',
    ],
    return_type: tab_1.ColumnType.NUMBER,
};
